import { gql } from 'apollo-client-ppc';

export const fetchSoldToAddressesForOrderReview = gql`
  query fetchSoldToAddressesForOrderReview($searchParams: ShipToPartySearchParams) {
    shipToParty(searchParams: $searchParams) {
      nodes {
        id
        name
        addressLine1
        addressLine2
        city
        state
        country
        postcode
        taxId
        priceEligibility
      }
    }
  }
`;
